
import React, { Component } from 'react';
import { translate } from "react-i18next";
import { sendJson, getURL } from '../../backend/Backend';
import {  Table, Button , Alert, Row, Col} from 'react-bootstrap';
import Parameter from "./Parameter";

class ParameterList extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.updateAll = this.updateAll.bind(this);

        this.state = {
            message: '',
            parameters: []
        }
    }



    async componentDidMount() {
        const response = await fetch(getURL(`parameters/all/0`));
        const json = await response.json();

        console.log("componentDidMount: " + JSON.stringify(json));

        let oldState = this.state;
        this.setState({
            ...oldState,
            parameters: json
        });
    }

    handleChange(oldParameter ) {

        let parameters = this.state.parameters;
        let p = parameters.find(p => p.key === oldParameter.key);
        let pIndex = parameters.findIndex(p => p.key === oldParameter.key);
     

        p.value = oldParameter.value === '1'?'0':'1';

       

        let newParameters = [...parameters.slice(0, pIndex),
            p,
          ...parameters.slice(pIndex + 1)];

        this.setState({
            parameters: newParameters
        });
    }


    updateAll(){
        sendJson('put', 'parameters/updateAll', this.state.parameters).then(
            received => {
              //this.props.onAdd(received); 
              if(received.ok){
                  console.log("parameters saved  :-)");
                  let oldState = this.state;
                  this.setState({
                      ...oldState,
                      message: received.message
                    });
                    setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
              }
            });
    }



    render() {
        const { t } = this.props;
       
        return (
            <div >
                <Table striped bordered hover responsive size="sm" >
                <tbody>
                    {this.state.parameters.map((parameter, i) => {
                       return <Parameter p={parameter} handleChange={ this.handleChange} />
                        
                    })}
                    </tbody>
                </Table>
                <Button   onClick={() => this.updateAll()} className="float-right mt-1 " size="sm"><span className={ "fa fa-save mr-2" } ></span>{t("speichern")}</Button>
                {this.state.message ?
          <Row className="mt-2">
            <Col>
              <Alert variant="success">
                <Row>
                  <Col>{t(this.state.message)}</Col>
                </Row>
              </Alert>

            </Col>
          </Row>

          :
          ""
        }

            </div>

        );
    }


}

export default translate("translations")(ParameterList);